((function($) {
  $(document).ready(function() {
    var recalcTotal = function() {
      var total = 0;
      var productPrice = $('#product-bundles .product_total').attr('price') * 1;
      total = productPrice;
      
      $('#product-bundles .options .option').each(function() {
        var optionPrice = $(this).attr('value') * 1;

        $(this).find('.option_quantity input').each(function() {
          var quantity = $(this).val() * 1;
          var optionTotal = optionPrice * quantity;

          total += (optionTotal * 1);
        });
      });
      
      total = total / 100;
      
      total = total.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      $('#product-bundles .product_total').html(total + "€");
    }

    var addToCart = function() {
      var addComplements = [
        {
            id: $('#product-bundles').attr('vid'),
            quantity: 1
        }
      ];

      /* Check requireds */
      var finalFound = true;
      
      $('#product-bundles .options.required').each(function() {
        var found = false;

        $(this).find('.option input').each(function() {
          if ($(this).val() > 0) found = true;
        });

        if (!found) {
          finalFound = false;
        }
      });

        window.showBundleAlert = function(message) {
          var $overlay = $('#bundle-alert-overlay');
          if (!$overlay.length) {
            console.warn('bundle-alert-overlay no encontrado. ¿Está renderizado el snippet en esta plantilla?');
            return;
          }
          if (message) $('#bundle-alert .msg').text(message);
          $overlay.addClass('is-active');
          $('body').css('overflow', 'hidden');
        };

        window.closeBundleAlert = function() {
          $('#bundle-alert-overlay').removeClass('is-active');
          $('body').css('overflow', '');
        };

        $(document).on('click', '#bundle-alert .close, #bundle-alert .btn', window.closeBundleAlert);
        $(document).on('click', '#bundle-alert-overlay', function(e) {
          if (e.target.id === 'bundle-alert-overlay') window.closeBundleAlert();
        });
        $(document).on('keydown', function(e) {
          if (e.key === 'Escape') window.closeBundleAlert();
        });

      if (!finalFound) {
        showBundleAlert('Rellena todos los campos requeridos, por favor!');
        return false;
      }

      /* Add complements */
      $('#product-bundles .options .option').each(function() {
        var variantId = $(this).attr('vid');
        
        $(this).find('.option_quantity input').each(function() {
          var quantity = $(this).val() * 1;

          if (quantity > 0) {
            addComplements.push({
              id: variantId,
              quantity: quantity
            });
          }
        });
      });
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"items": addComplements})
      })
      .then(response => response.json())
      .then(data => {
        console.log('Producto añadido al carrito:', data);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      })
      .catch(error => {
        console.error('Error al añadir al carrito:', error);
      });
    }

    // Add to Cart
    $('#productBundleAddToCart').click(function(event) {
      if ($(this).is('.disabled') || $(this).attr('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      addToCart();
    });
    
    // Minus button
    $('#product-bundles .option_quantity button[name="minus"]').click(function() {
      var actual = ($(this).parent().find('input').val() * 1) - 1;
      if (actual < 0) actual = 0;
      $(this).parent().find('input').val(actual);

      recalcTotal();
    });

    // Plus button
    $('#product-bundles .option_quantity button[name="plus"]').click(function() {
      var actual = ($(this).parent().find('input').val() * 1) + 1;
      var max = $(this).parent().find('input').attr('max');
      if (actual > max) actual = max;
      $(this).parent().find('input').val(actual);

      recalcTotal();
    });
  });
})(jQuery));